import { render, staticRenderFns } from "./MultipleSelectContentQuestion.vue?vue&type=template&id=6f6c6c76"
import script from "./MultipleSelectContentQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleSelectContentQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultipleSelectContentQuestion.vue?vue&type=style&index=0&id=6f6c6c76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports